import { render, staticRenderFns } from "./CategoryValueDisplay.vue?vue&type=template&id=d9e480e0&scoped=true&"
import script from "./CategoryValueDisplay.vue?vue&type=script&lang=ts&"
export * from "./CategoryValueDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryValueDisplay.vue?vue&type=style&index=0&id=d9e480e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9e480e0",
  null
  
)

export default component.exports